import { render, staticRenderFns } from "./Surtir.vue?vue&type=template&id=eb16efe0&"
import script from "./Surtir.vue?vue&type=script&lang=js&"
export * from "./Surtir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports